import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router';

// Pages
import { NavigationContextProvider, OrganizationsProvider } from '@engecomp/shared/contexts';
import { RPaths } from '@engecomp/shared/utils';

import { ChooseCompanyPage, ForgotPassword, Login, PasswordRecovery } from '@pages/auth';

import ErrorPage from './error-page';

export function Router() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <NavigationContextProvider {...{ navigate, location, Outlet: <Outlet /> }}>
      <Routes>
        <Route element={<Outlet />} errorElement={<ErrorPage />} path={RPaths.auth.root}>
          <Route element={<Login />} path={RPaths.auth.login} />
          <Route
            element={
              <OrganizationsProvider>
                <ChooseCompanyPage />
              </OrganizationsProvider>
            }
            path={RPaths.auth.chooseCompany}
          />
          <Route element={<ForgotPassword />} path={RPaths.auth.forgotPassword} />
          <Route element={<PasswordRecovery />} path={RPaths.auth.resetPassword} />
        </Route>

        <Route path='*' element={<Navigate to='/' />} />
      </Routes>
    </NavigationContextProvider>
  );
}
